export default "__VITE_ASSET__a0cJpe0m__"